import { createContext, useContext } from 'react'

import { useCategoriesState } from '../../hooks'

import type { CategoriesState } from '../../types'
import type { ReactNode } from 'react'

const CategoryContext = createContext<CategoriesState | undefined>(undefined)

interface CategoriesProductsProviderProps {
  children: ReactNode
}

/**
 * Thin Provider for categories and products state
 * Calls useCategoriesState composition hook
 */
export function CategoriesProductsStateProvider({ children }: CategoriesProductsProviderProps) {
  const value = useCategoriesState()

  return <CategoryContext value={value}>{children}</CategoryContext>
}

export function useCategoriesAndProductsContextProvider(): CategoriesState {
  const context = useContext(CategoryContext)
  if (!context) {
    throw new Error('useCategoriesAndProductsContextProvider must be used within a CategoriesProductsStateProvider')
  }
  return context
}
